import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';
import iconFanzhuan from '../assets/fanzhuan.png';
import iconShichui from '../assets/shichui.png';

const Milestone = ({ id }) => {
    const getMilestone = id => {
        switch (id) {
            case 1:
                return <img src={iconFanzhuan} alt="" className={styles.milestone} />;
            case 2:
                return <img src={iconShichui} alt="" className={styles.milestone} />;
            default:
                return null;
        }
    };

    return <>{getMilestone(id)}</>;
};

Milestone.propTypes = {
    id: PropTypes.number,
};

export default errorBoundary(Milestone);
